export default __webpack_public_path__ + "static/media/tenor.c26b56bf.gif";